import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { IIcon } from '../../../shared/components/icon/icon.interface';

@Component({
  selector: 'app-basic-feed-list-item',
  templateUrl: 'basic-feed-list-item.component.html',
  styleUrls: ['basic-feed-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BasicFeedListItemComponent implements OnInit {
  @Input() type: string;
  @Input() identifier: string;
  @Input() header: string;
  @Input() headerIcon: IIcon;
  @Input() separateHeaderAndDescription: boolean = true;
  @Input() description: string;
  @Input() descriptionIcon: IIcon;
  @Input() descriptionTruncateThreshold: number;
  @Input() subDescription: string;
  @Input() subDescriptionTruncateThreshold: number;
  @Input() metadataHeader: string;
  @Input() metadataDescription: string;
  @Input() primaryActionText: string;
  @Input() deletable: boolean;
  @Input() secondaryActionText: string;

  @Output() onPrimaryAction: EventEmitter<void> = new EventEmitter<void>();
  @Output() onSecondaryAction: EventEmitter<void> = new EventEmitter<void>();

  constructor() {}

  ngOnInit() {}

  onPrimaryActionClick(evt: Event) {
    evt.preventDefault();
    evt.stopPropagation();

    this.onPrimaryAction.emit();
  }

  onSecondaryActionClick(evt: Event) {
    evt.preventDefault();
    evt.stopPropagation();

    this.onSecondaryAction.emit();
  }
}
